import React from "react";
import GoogleMapReact from "google-map-react";
import { MdLocationPin } from "react-icons/md";
import { configs } from "@config/config";

const MapMarker = ({ text }) => <div>{text}</div>;

const GoogleMap = ({ lat, long, zoom = 12 }) => {
  const defaultProps = {
    center: {
      lat: lat,
      lng: long,
    },
    zoom: zoom,
  };

  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden", position: "relative" }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: configs?.google_map_auth_key }}
        center={defaultProps.center}
        zoom={defaultProps.zoom}
      >
        <MapMarker
          lat={lat}
          lng={long}
          text={
            <MdLocationPin
              style={{ color: "#de0a26", height: "1.5rem", width: "1.5rem" }}
            />
          }
        />
      </GoogleMapReact>
    </div>
  );
};

export default GoogleMap;
